<template>
  <div class="page">
    <section class="page-hero">
      <div class="container">
        <span class="eyebrow light">ABOUT VOLTEDGE</span>
        <h1>Engineering reliability<br><span>into every system.</span></h1>
        <p>We help facilities in Port Harcourt and across Rivers State solve critical power, protection, communication and security needs.</p>
      </div>
    </section>

    <section class="section about-intro">
      <div class="container about-grid">
        <div><span class="eyebrow">OUR APPROACH</span><h2>We start with the facility, not the product.</h2></div>
        <div><p>Good engineering begins by understanding the environment. What equipment needs power? Where are the risks? How do people communicate? What needs to be protected? What happens when the grid fails?</p><p>Our role is to bring those questions together and develop practical systems that make a facility more resilient, safer and easier to operate.</p></div>
      </div>
    </section>

    <section class="section section-soft">
      <div class="container">
        <SectionHeading eyebrow="WHAT WE VALUE" title="Built around five principles." centered />
        <div class="values-grid">
          <div v-for="value in values" :key="value.title" class="value-card"><span>{{ value.number }}</span><h3>{{ value.title }}</h3><p>{{ value.text }}</p></div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container stats-row">
        <div><strong>01</strong><span>Site-first<br>thinking</span></div>
        <div><strong>05</strong><span>Integrated<br>solution areas</span></div>
        <div><strong>24/7</strong><span>Designed for<br>critical operations</span></div>
        <div><strong>PH</strong><span>Based in<br>Port Harcourt</span></div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionHeading from '../components/SectionHeading.vue'
export default {
  name: 'About',
  components: { SectionHeading },
  data() {
    return {
      values: [
        { number: '01', title: 'Reliability', text: 'Systems should perform when they are needed most.' },
        { number: '02', title: 'Clarity', text: 'Straightforward recommendations without unnecessary complexity.' },
        { number: '03', title: 'Safety', text: 'Protection is designed into the solution from the beginning.' },
        { number: '04', title: 'Precision', text: 'Measurements, planning and installation matter.' },
        { number: '05', title: 'Support', text: 'A project should have a dependable technical partner behind it.' }
      ]
    }
  }
}
</script>